import axios from 'axios';
import querystring from 'querystring';

import { fdApiUse } from '../apiUtils';
import {
  CrossSellMenuItems,
  GetCrossSellMenuItemIdsQueryParams,
  Menu,
  NutritionInfo,
} from './menu.types';

// #region get requests
export const getCrossSellMenuItemIds = (
  queryParams: GetCrossSellMenuItemIdsQueryParams,
): Promise<CrossSellMenuItems> =>
  fdApiUse(
    axios.get('/crossSell/menuItems', {
      params: queryParams,
      paramsSerializer: (params) => querystring.stringify(params),
    }),
  ).then((data: CrossSellMenuItems) => data);

export const getMenu = (menuUrl: string): Promise<Menu> =>
  fdApiUse(axios.get(menuUrl, { withCredentials: false }), true);

export const getNutritionInfo = (
  nutritionInfoUrl: string,
): Promise<NutritionInfo> =>
  fdApiUse(axios.get(nutritionInfoUrl, { withCredentials: false }), true);
// #endregion
